<template>
  <div class="container">
      <div class="topDiv">
          <div class="topDiv_item"  @click="select(1)">
              <span class="topDiv_item_span">{{HT}}</span>
              <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
          </div>
          <div class="topDiv_item" @click="select(2)">
              <span class="topDiv_item_span">{{year}}</span>
              <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
          </div>
      </div>
      <div class="topbody">
          <!-- <span class="topbody_span1">{{HT}}</span> 
    color: #A3805A;-->
          <span :class="$store.state.common.theme !=3 ? 'topbody_span2' :'topbody_span2_change'">{{details.revenueMonthTotal}}</span>
          <span class="topbody_span3">月销售总额(元)</span>
      </div>
      <div class="tableTop">
          <span class="tableTop_span1">每日营报明细</span>
          <div class="tableTop_right">
            <span class="tableTop_span2">已填: {{details.revenueFilledNum}}</span>
            <span class="tableTop_span3">未填: {{details.revenueUnfilledNum}}</span>
          </div>
      </div>
         <div class="shop_list1" v-if="dataList.length>0">
            <scroll  :allLoaded="false" :data="dataList" :pullup="false" @pulldown="loadData" >
                <section @click="pushToDetail(item)" class="list_cell" v-for="(item,index) in dataList_isOutTime" :key="index">
                    <span class="item_date">{{item.month+'月'+item.day+'日'}}</span>
                    <div class="item_right">
                        <span v-if="item.revenue" class="item_right_span">{{item.revenue}}</span>
                        <span v-else class="item_right_span1">未填</span>
                        <img class="item_arrow" src="./../../assets/images/me/right.png" />
                    </div>
                 </section>
            </scroll>
         </div>


      <!-- // 此处slots为动态传入的值，通过computed来处理，数据通过vuex管理，由于数据为对象数组，需设置 value-key 属性来指定显示的字段名 -->
      <mt-popup  v-model="popupVisible" position="bottom" class="mint-popup">
      <mt-picker class="picker" :slots="pickList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
            <div class="picker_wrap">
                <div class="picker_btn" @click="popupVisible=false">取消</div>
                <div class="picker_btn2" @click="handleConfirm">确认</div>
            </div>
            </mt-picker>
      </mt-popup>
   </div>
</template>
<script>
import { getContractList,getRevenueList} from "../../utils/api";
import Scroll from "../../components/scroll";
import { mapState } from 'vuex';
export default {
  name: "billDetail",
  components: {
     Scroll,
  },
  computed: {
    ...mapState({
      common: state => state.common,
    }),
    dataList_isOutTime(){
        return this.dataList.filter(item=>{
            return !item.isOutTime
        })
    }
  },
  filters: {
    checkMath(val){
      return val?val.split('-')[1]:'';
    }
  },
  data() {
    return {
      activeTab: 1,
      result:'', //合同数组
      details:'',
      dataList: [],
      allLoaded:true,
      isLoaded:false,
      year:'2019年9月',
      yearList:[{
        flex: 1,
        values:[] ,
        className: 'slot1',
        textAlign: 'center'
      }],
      pYear:'',
      pMonth:'',
      //["2019","2018","2017","2016","2015","2014","2013","2012","2011","2010"],
      HT:"",
      HTId:'',
      //HTNameList:["全部合同","合同1","合同2","合同3","合同4","合同5"],
      HtIdList:[],
      contBeginDate:'',
      contEndDate:'',

      HTNameList: [{
        flex: 1,
        values:[] ,
        className: 'slot1',
        textAlign: 'center'
      }],

      //弹框选择
      pickType:'',
      popupVisible:false,
      pickList:[],
    }
  },

  created(){
      // this.initYears();
       this.getContractList();
    //  this.geHistoryBillingByParam();

  },
  activated () {
      if(this.HTId){
        this.getRevenueList();
      }
    // this.getOnlineBillingByParam();
  },

   methods: {
       initYears(){
           var currentDate = new Date();
           var endYear = currentDate.getFullYear();
           var endMonth = currentDate.getMonth() + 1;
           var endYear1 = currentDate.getFullYear();    //当前年
           var endMonth1 = currentDate.getMonth() + 1;  //当前月
           var nYS= endYear1+'-'+endMonth1;
           var yearList =[];

           var beginYear =2009;
           var beginMonth=0;
           if(this.contBeginDate){
                var cBeginDate  = new Date(this.contBeginDate);
                beginYear = cBeginDate.getFullYear();
                beginMonth = cBeginDate.getMonth()+1 ;
           }
           if(this.contEndDate){
                var cEndDate = new Date(this.contEndDate);
                endYear = cEndDate .getFullYear();
                endMonth = cEndDate .getMonth()+1 ;
           }
           endYear =parseInt(endYear);
           endMonth= parseInt(endMonth);
           beginYear =parseInt(beginYear);
           beginMonth =parseInt(beginMonth);
           for(var i= beginYear ;i<=endYear;i++){
                var maxj=12;
                var minJ=1;
                if(i==endYear){
                    maxj= endMonth;
                }
                if(i== beginYear){
                    minJ =beginMonth;
                }
                for(var j=minJ;j<=maxj;j++){
                    var ys= i+'年'+j+'月'
                    yearList.push(ys);
                }
           }
           this.yearList[0].values=yearList;
           var hasNys=false;
           for(var k=0;k<yearList.length;k++){
               if(nYS ==yearList[k]){
                   hasNys =true;
               }
           }
           if(hasNys){
                this.year=endYear1+"年"+endMonth1+"月";
                this.pYear =endYear1;
                this.pMonth =endMonth1;
           }else{
                if(this.endYear>parseInt(this.endYear1)){
                    this.year=endYear+"年"+endMonth+"月";
                    this.pYear =endYear;
                    this.pMonth =endMonth;
                }else{
                    this.year=beginYear+"年"+beginMonth+"月";
                    this.pYear =beginYear;
                    this.pMonth =beginMonth;

                }
           }
      },
        //上拉
     loadup(){
      //  console.log("in loadup");
      //  if(this.isLoding){
      //    return;
      //  }
      //  if(this.allLoaded){
      //    return;
      //  }
      //  this.pageNo=this.pageNo+1;
      //  this.getNoticeListAction();
     },

     //下拉刷新
     loadData(){
      //  if(this.isLoding){
      //    return;
      //  }
      //  this.pageNo=1;
      //  this.allLoaded =false;
      //  this.getNoticeListAction();
     },
     getContractList(){
        let params = {  //先取全部合同
            'userId': this.common.userId,
             "pageNo": 1,
            "pageSize": 100,
            // "layout":0,
            "permissionType": 'REVENUE'
        }
         getContractList(params).then(res => {
             var nameList =[];
             var idList =[];
             if (res.res.code === 10000 && res.body) {
                let data = res.body;
                this.result = data.contractList;
                for(var i=0;i<this.result.length;i++){
                    if(i==0){
                        this.HT = this.result[i].contNo
                        this.HTId = this.result[i].localId
                        this.contBeginDate= this.result[i].contBeginDate
                        this.contEndDate =this.result[i].contEndDate
                        this.initYears();
                    }
                    nameList.push(this.result[i].contNo);
                    idList.push(this.result[i].localId);
                }
             }

             this.HTNameList[0].values=nameList;
             this.HtIdList =idList;

             this.getRevenueList();
         });


     },
     getRevenueList(){
         let params = {
            userId: this.common.userId,
            //   yearMonth: this.year,
            year:String(this.pYear) ,
            month:String(this.pMonth),
            contId: this.HTId,
            companyId:this.common.userTenantInfo.companyId
        }
        // 对应SaaS接口 /finance/rveRevenueHeaderApp/queryRveRevenueOneMonth
        getRevenueList(params).then(ret => {
          console.log(ret)
          if (ret.res.code === 10000) {
            this.details = ret.body
            this.dataList =ret.body.rveRevenueItemVoList ;
            if(!this.dataList){
                this.dataList =[];
            }

            var beginYear =2009;
            var beginMonth=0;
            var beginDay=1;
           if(this.contBeginDate){
                var cBeginDate  = new Date(this.contBeginDate);
                beginYear = cBeginDate.getFullYear();
                beginMonth = cBeginDate.getMonth()+1 ;
                beginDay = cBeginDate.getDate();

           }
           beginYear =parseInt(beginYear);
           beginMonth =parseInt(beginMonth);
           beginDay =parseInt(beginDay);
           if(this.pYear == beginYear && this.pMonth ==beginMonth){
               for(var i=0;i<this.dataList.length;i++){
                   var item = this.dataList[i];
                   if(item.day<beginDay){
                       item.canEdit=false;
                       item.isOutTime =true;
                   }
               }
           }
           var currentDate = new Date();
           var endYear = currentDate.getFullYear();
           var endMonth = currentDate.getMonth() + 1;
           var endDay=1;
            if(this.contEndDate){
                var cEndDate = new Date(this.contEndDate);
                endYear = cEndDate .getFullYear();
                endMonth = cEndDate .getMonth()+1 ;
                endDay = cEndDate.getDate();
           }
           endYear =parseInt(endYear);
           endMonth =parseInt(endMonth);
           endDay =parseInt(endDay);
           if(this.pYear == endYear && this.pMonth ==endMonth){
               for(var j=0;j<this.dataList.length;j++){
                   var item1 = this.dataList[j];
                   if(item1.day>endDay){
                       item1.canEdit=false;
                       item1.isOutTime =true;
                   }
               }
           }


          } else {
            //toast.showMessage(ret.res.msg)
          }
        })

     },

        select(pickType){
            this.pickType=pickType;
            this.popupVisible=true;
            if(this.pickType==1){
                this.pickList = this.HTNameList;
            }else{
                this.pickList = this. yearList;
            }

        },
        onValuesChange (picker, values) {
            if (values[0] > values[1]) {
                picker.setSlotValue(1, values[0]);
            }
        },

        handleConfirm(){
            this.popupVisible = false
            var valve =  this.$refs.picker.getValues()[0];
            if(this.pickType==1){
                this.HT=valve
                var list =this.HTNameList[0].values;
                for(var i=0;i<list.length;i++){
                    if(valve==list[i]){
                        this.HTId=this.HtIdList[i];
                        this.contBeginDate= this.result[i].contBeginDate
                        this.contEndDate =this.result[i].contEndDate
                        this.initYears();

                    // break;
                    }
                }
            }else{
                this.year=valve
                var llist = valve.split("年");
                var llist2 = llist[1].split("月");
                this.pYear =llist[0];
                this.pMonth =llist2[0];
            }
            this.getRevenueList();

        },

        pushToDetail(item){
         // 合同id：contId；年：year；月：month；日：day
          if(item.isOutTime ==true){
                //
          }else{
                var param = "contId="+this.HTId+"&year="+item.year+'&month='+item.month+'&day='+item.day;
                var url ='/revenueForm?'+param;
                this.$router.push(url);
          }

        },
   }


}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #EDEDED;
  .flex(column);
  .shop_list1 {
    flex: 1;
    height: 500px;

  }
}

.topDiv{
    width: 100%;
    height: 88px;
    flex-direction: row;
    background:#EDEDED;
    display: flex;
}
.topDiv_item{
    height: 88px;
    width: 50%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    display: flex;
}
.topDiv_item_span{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.topDiv_item_icon{
    width: 24px;
    height: 24px;
    margin-left: 16px;
    display: flex;
}
//topbody
.topbody{
    flex-direction: column;
    display: flex;
    width: 100%;
    height:252px;
    background:rgba(255,255,255,1);
    // justify-content: center;
    // align-items: center;

}
.topbody_span1{
    width: 100%;
    text-align: center;
    margin-top: 40px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.topbody_span2{
    width: 100%;
    text-align: center;
    margin-top: 60px;
    height:72px;
    font-size:60px;
    font-weight:bold;
    color:rgba(23,64,218,1);
    line-height:72px;
}
.topbody_span2_change{
    width: 100%;
    text-align: center;
    margin-top: 60px;
    height:72px;
    font-size:60px;
    font-weight:bold;
    line-height:72px;
    color: #A3805A;
}
.topbody_span3{
    width: 100%;
    text-align: center;
    margin-top: 20px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
}
//tableTop
.tableTop{
    width: 100%;
    flex-direction: row;
    display: flex;
    height:88px;
    background:rgba(244,244,244,1);
    justify-content: space-between;
}
.tableTop_span1{
    margin-left: 28px;
    margin-top: 24px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;

}
.tableTop_right{
    margin-right: 20px;
    margin-top: 24px;
    flex-direction: row;
    justify-content:flex-end;

}
.tableTop_span2{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;
    margin-right: 34px

}
.tableTop_span3{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(253,152,56,1);
    line-height:40px;

}
//list
.list_cell{
    width:100%;
    height:100px;
    background:rgba(255,255,255,1);
    flex-direction: row;
    display: flex;
    border-bottom: 1px solid #eaeaea;
    justify-content: space-between;
    align-items: center;

}
.item_date{
    margin-left: 28px;
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.item_right{
    flex-direction: row;
    justify-content: flex-end;
    display: flex;
    height:100px;
    align-items: center;
    margin-right: 20px;

}
.item_right_span{
    height:44px;
    font-size:32px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.item_right_span1{
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:44px;
}
.item_arrow{
    width: 32px;
    height: 32px;
    margin-left: 16px;
}


//pick
.picker {
    width: 100%;
}
.picker-items {
    height: 100px!important;
}
.picker_wrap {
    height: 100px;
    display: flex;
    justify-content: space-between;
    padding: 0 28px;
    box-sizing: border-box;
}
.picker_btn,
.picker_btn2 {
    flex: 1;
    font-size: 32px;
    text-align: left;
    line-height: 100px;
}
.picker_btn2 {
    text-align: right;
    color: @color17;
}

.nodataView{
    width: 100%;
    height: 500px;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;

  }
  .nodataImage{
    width: 200px;
    height: 200px;
  }
  .nodataspan{
      margin-top: 10px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
  }


</style>
